<style scoped>
.venue-coach-details
  .accordion
  .accordion-item#overview
  .collapse.show
  .text.show-more-height,
.venue-coach-details
  .accordion
  .accordion-item#short-bio
  .collapse.show
  .text.show-more-height {
  transition: all 0.7s ease-in-out 0s;
  height: auto;
  overflow: unset;
}

.accordion-body p {
  color: rgba(25, 35, 53, 0.95);
}
</style>

<template>
  <div class="venue-coach-details coach-detail">
    <layouts-header v-if="!authStore.user"></layouts-header>
    <user-header v-if="authStore.user"></user-header>

    <!-- Banner -->
    <div class="banner">
      <img
        alt="Banner"
        src="@/assets/img/bg/breadcrumb1.jpg"
        style="width: 100%"
      />
    </div>

    <!-- Page Content -->
    <div class="content">
      <div class="container">
        <!-- Row -->
        <div class="row move-top">
          <div class="col-12 col-sm-12 col-md-12 col-lg-8">
            <div
              class="dull-bg corner-radius-10 coach-info d-md-flex justify-content-start align-items-start"
            >
              <div class="profile-pic" style="width: 139px; height: 160px">
                <a href="javascript:void(0);"
                  ><img
                    :alt="`${detail?.photo?.documentId}`"
                    :src="`${url + detail?.photo?.url}`"
                    class="corner-radius-10"
                    width="100%"
                /></a>
              </div>
              <div class="info w-100">
                <div
                  class="d-sm-flex justify-content-between align-items-start"
                >
                  <h3
                    class="d-flex align-items-center justify-content-start mb-0"
                  >
                    {{ detail.name
                    }}<span
                      class="d-flex justify-content-center align-items-center"
                    >
                      <i class="fas fa-check-double"></i
                    ></span>
                  </h3>
                  <div v-if="authStore.user" class="ml-auto">
                    <a-button
                      :loading="followLoading"
                      :type="isFollowing ? 'default' : 'primary'"
                      @click="toggleFollow"
                    >
                      <template #icon>
                        <i
                          :class="isFollowing ? 'fas fa-star' : 'far fa-star'"
                        ></i>
                      </template>
                      {{ isFollowing ? "Bỏ theo dõi" : "Theo dõi" }}
                    </a-button>
                  </div>
                </div>
                <p>
                  <span :class="style">{{ status }}</span>
                </p>
                <ul class="d-sm-flex align-items-center">
                  <li class="d-flex align-items-center">
                    <div class="white-bg d-flex align-items-center review">
                      <span>{{ detail?.num_player }} người tham gia</span>
                    </div>
                  </li>
                  <!-- <li>
                    {{ detail?.arenas[0]?.name ?? "" }}
                  </li> -->
                </ul>
                <hr />
                <ul class="d-xl-flex">
                  <li class="d-flex align-items-center">
                    <img alt="Icon" src="@/assets/img/icons/expert.svg" />Tổng
                    giải thưởng: {{ total_ }}
                  </li>
                  <li class="d-flex align-items-center">
                    <img alt="Icon" src="@/assets/img/icons/since.svg" /> Ngày
                    bắt đầu:
                    {{ formatNewDate(detail?.date_start) }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="venue-options white-bg mb-4">
              <ul class="clearfix">
                <li><a href="#short-bio">Chi tiết giải đấu</a></li>
                <li><a href="#location">Địa điểm</a></li>
                <li><a href="#ranked">Xếp hạng</a></li>
                <li v-if="isShowPlayer"><a href="#player">Vận động viên</a></li>
                <li v-if="isShowTeamPlayer">
                  <a href="#team_player">Danh sách đội</a>
                </li>
                <li><a href="#matches">Trận đấu</a></li>
              </ul>
            </div>

            <div class="content court-bg mb-3">
              <div class="court-tab-content">
                <div class="card card-tableset">
                  <div class="card-body">
                    <div class="tab-content">
                      <div class="coache-head-blk">
                        <div class="row align-items-center">
                          <div class="col-md-5">
                            <div class="court-table-head">
                              <h4 class="">Trận đấu đang diễn ra</h4>
                            </div>
                          </div>
                          <div class="tab-pane fade show active">
                            <match-ongoing
                              :documentId="detail?.documentId"
                              :tournament="detail"
                            ></match-ongoing>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Accordian Contents -->
            <div id="accordionPanel" class="accordion">
              <div id="short-bio" class="accordion-item mb-4">
                <h4 id="panelsStayOpen-short-bio" class="accordion-header">
                  <button
                    aria-controls="panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    class="accordion-button"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    data-bs-toggle="collapse"
                    type="button"
                  >
                    Chi tiết giải đấu
                  </button>
                </h4>
                <div
                  id="panelsStayOpen-collapseOne"
                  aria-labelledby="panelsStayOpen-short-bio"
                  class="accordion-collapse collapse show"
                >
                  <div class="accordion-body">
                    <div class="text show-more-height">
                      <p class="mb-0">Tên giải đấu: {{ detail?.name }}</p>
                      <p class="mb-4">
                        Hình thức thi đấu: {{ typeTournament }}
                      </p>
                      <p class="mb-4">
                        Số vận động viên tham gia: {{ detail?.num_player }}
                      </p>
                      <p class="mb-4">
                        Ngày bắt đầu: {{ formatNewDate(detail?.date_start) }}
                      </p>
                      <p class="mb-4">
                        Ngày kết thúc: {{ formatNewDate(detail?.date_end) }}
                      </p>
                      <h6 class="mb-2">Mô tả:</h6>
                      <p class="mb-4">{{ detail?.description ?? "---" }}</p>
                      <h6 class="mb-2">Luật chơi:</h6>
                      <p class="mb-4">{{ detail?.rule ?? "---" }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div id="matches" class="accordion-item mb-4">
                <h4 id="matches-ranked" class="accordion-header">
                  <button
                    aria-controls="matches-collapseFive"
                    aria-expanded="false"
                    class="accordion-button collapsed"
                    data-bs-target="#matches-collapseFive"
                    data-bs-toggle="collapse"
                    type="button"
                  >
                    Danh sách trận đấu
                  </button>
                </h4>
                <div
                  id="matches-collapseFive"
                  aria-labelledby="matches-ranked"
                  class="accordion-collapse collapse"
                >
                  <div class="accordion-body">
                    <tour-match-table :tournament="detail"></tour-match-table>
                  </div>
                </div>
              </div>
              <div id="ranked" class="accordion-item mb-4">
                <h4 id="panelsStayOpen-ranked" class="accordion-header">
                  <button
                    aria-controls="panelsStayOpen-collapseFive"
                    aria-expanded="false"
                    class="accordion-button collapsed"
                    data-bs-target="#panelsStayOpen-collapseFive"
                    data-bs-toggle="collapse"
                    type="button"
                  >
                    Xếp hạng giải đấu
                  </button>
                </h4>
                <div
                  id="panelsStayOpen-collapseFive"
                  aria-labelledby="panelsStayOpen-ranked"
                  class="accordion-collapse collapse"
                >
                  <div class="accordion-body">
                    <div v-if="isShowPlayer" class="">
                      <div class="coache-head-blk mb-3">
                        <div class="row align-items-center">
                          <div class="col-md-5">
                            <div class="court-table-head">
                              <h6>Thể thức: Cá nhân</h6>
                            </div>
                          </div>
                          <div class="col-md-7">
                            <div class="table-search-top">
                              <div id="tablefilter">
                                <div class="dataTables_filter">
                                  <label>
                                    <select
                                      v-model="selectedCategory"
                                      class="form-control"
                                      style="min-width: unset"
                                      @change="searchCategory"
                                    >
                                      <option
                                        v-for="item in optionCategories"
                                        :key="item.value"
                                        :value="item.value"
                                      >
                                        {{ item.label }}
                                      </option>
                                    </select>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="table-responsive table-datatble">
                        <table
                          class="table table-borderless dashboard-card-table"
                        >
                          <colgroup>
                            <col width="10%" />
                            <col width="x" />
                            <col width="20%" />
                          </colgroup>
                          <thead class="thead-light">
                            <tr>
                              <th>Xếp hạng</th>
                              <th>Vận động viên</th>
                              <th>Điểm</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, index) in dataRank"
                              :key="item.id"
                              :data-key="index"
                            >
                              <td>
                                {{ item?.rank }}
                              </td>
                              <td>
                                <h5>
                                  {{
                                    item?.tour_player_team?.player_1
                                      ?.display_name
                                  }}
                                  <br />
                                  {{
                                    item?.tour_player_team?.player_2
                                      ?.display_name
                                  }}
                                </h5>
                              </td>
                              <td>
                                <h4>{{ item?.point }}</h4>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div v-if="isShowTeamPlayer" class="">
                      <div class="coache-head-blk mb-3">
                        <div class="row align-items-center">
                          <div class="col-md-5">
                            <div class="court-table-head">
                              <h6>Thể thức: Đồng đội</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="table-responsive table-datatble">
                        <table class="table">
                          <colgroup>
                            <col width="10%" />
                            <col width="x" />
                            <col width="20%" />
                          </colgroup>
                          <thead class="thead-light">
                            <tr>
                              <th>Xếp hạng</th>
                              <th>Đội</th>
                              <th>Điểm</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, index) in dataTeamRank"
                              :key="item.id"
                              :data-key="index"
                            >
                              <td>
                                {{ item?.rank }}
                              </td>
                              <td>
                                <h5>
                                  {{ item?.team?.name }}
                                </h5>
                              </td>
                              <td>
                                <h4>{{ item?.point }}</h4>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="location" class="accordion-item mb-4">
                <h4 id="panelsStayOpen-location" class="accordion-header">
                  <button
                    aria-controls="panelsStayOpen-collapseSeven"
                    aria-expanded="false"
                    class="accordion-button collapsed"
                    data-bs-target="#panelsStayOpen-collapseSeven"
                    data-bs-toggle="collapse"
                    type="button"
                  >
                    Địa điểm
                  </button>
                </h4>
                <div
                  id="panelsStayOpen-collapseSeven"
                  aria-labelledby="panelsStayOpen-location"
                  class="accordion-collapse collapse"
                >
                  <div class="accordion-body">
                    <div
                      v-for="(arena, index) in arenas"
                      :key="arena.documentId ?? index"
                      class="dull-bg d-flex justify-content-start align-items-center mb-0"
                    >
                      <div class="white-bg me-2">
                        <i class="fas fa-location-arrow"></i>
                      </div>
                      <div>
                        <h6>
                          Nhà thi đấu: {{ arena?.name || "Không có tên" }}
                        </h6>
                        <p>
                          Địa chỉ: {{ arena?.address ?? "Không có địa chỉ" }}
                        </p>
                        <p v-if="arena?.courts?.length">
                          Sân thi đấu:
                          {{
                            arena.courts
                              .map((court) => court?.name || "Không có địa chỉ")
                              .join(", ")
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isShowPlayer" id="player" class="accordion-item mb-4">
                <h4 id="player-ranked" class="accordion-header">
                  <button
                    aria-controls="player-collapseFive"
                    aria-expanded="false"
                    class="accordion-button collapsed"
                    data-bs-target="#player-collapseFive"
                    data-bs-toggle="collapse"
                    type="button"
                  >
                    Vận động viên
                  </button>
                </h4>
                <div
                  id="player-collapseFive"
                  aria-labelledby="panelsStayOpen-ranked"
                  class="accordion-collapse collapse"
                >
                  <div class="accordion-body">
                    <tour-player-table :tournament="detail"></tour-player-table>
                  </div>
                </div>
              </div>
              <div
                v-if="isShowTeamPlayer"
                id="team_player"
                class="accordion-item mb-4"
              >
                <h4 id="team_player-ranked" class="accordion-header">
                  <button
                    aria-controls="team_player-collapseFive"
                    aria-expanded="false"
                    class="accordion-button collapsed"
                    data-bs-target="#team_player-collapseFive"
                    data-bs-toggle="collapse"
                    type="button"
                  >
                    Danh sách đội
                  </button>
                </h4>
                <div
                  id="team_player-collapseFive"
                  aria-labelledby="panelsStayOpen-ranked"
                  class="accordion-collapse collapse"
                >
                  <div class="accordion-body">
                    <tour-team-table :tournament="detail"></tour-team-table>
                  </div>
                </div>
              </div>
            </div>
            <!-- Accordian Contents -->
          </div>
          <detail-sidebar
            :categories="categories"
            :detail="detail"
          ></detail-sidebar>
        </div>
        <!-- /Row -->
      </div>
      <!-- /container -->
    </div>
    <!-- /Page Content -->
  </div>

  <layout-footer></layout-footer>

  <coach-detail-modal></coach-detail-modal>
</template>

<script setup>
import { ref, watch, computed, watchEffect, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useFollowStore } from "@/stores/follow";
import { useQuery } from "@vue/apollo-composable";
import { GET_TOURNAMENT_BY_NAME } from "@/graphql/operations/tournament.ts";
import {
  GET_CATEGORY_RANKS,
  GET_CATEGORY_TEAM_RANKS,
} from "@/graphql/operations/tournament-rank.ts";
import convertNumberToCurrency from "@/utils/ConvertNumberToCurrency";
import { formatNewDate } from "@/utils/datetime";
import { useAuthStore } from "@/stores/auth";
import TourMatchTable from "@/interface/pages/tournament/inc/tourmatch-table.vue";
import { Button as AButton } from "ant-design-vue";
import {
  subscribeFollow,
  unsubscribeFollow,
  checkFollowStatus,
} from "@/api/strapi/follow";
import { message } from "ant-design-vue";

const route = useRoute();
const params = route.params.name;
const authStore = useAuthStore();

const detail = ref([]);
const arenas = ref([]);
const categories = ref([]);
const dataRank = ref([]);
const dataTeamRank = ref([]);
const total_ = ref(0);
const status = ref("");
const typeTournament = ref("");
const style = ref("");
const selectedCategory = ref("");
const isShowPlayer = ref(false);
const isShowTeamPlayer = ref(false);
const category = ref([]);
const pagination = ref({
  current: 1,
  pageSize: 9999,
  total: 0,
  showSizeChanger: true,
});
const optionCategories = ref([]);

const statusMap = {
  upcoming: { text: "Sắp diễn ra", class: "badge bg-info" },
  ongoing: { text: "Đang diễn ra", class: "badge bg-primary" },
  finished: { text: "Đã kết thúc", class: "badge bg-success" },
  canceled: { text: "Đã huỷ", class: "badge bg-danger" },
};

function mapType(t) {
  switch (t) {
    case "single":
      return { label: "Cá nhân", showPlayer: true, showTeam: false };
    case "team":
      return { label: "Đồng đội", showPlayer: false, showTeam: true };
    default:
      return { label: "Kết hợp", showPlayer: true, showTeam: true };
  }
}

const { result: tournament } = useQuery(GET_TOURNAMENT_BY_NAME, {
  name: params[0],
});

const filtersTeamRank = computed(() => ({
  tournament: { documentId: { eq: detail.value?.documentId || "" } },
}));

const paginationOptions = computed(() => ({
  page: Number(pagination.value.current),
  pageSize: Number(pagination.value.pageSize),
}));
const sortOptions = ["rank:asc"];

const filtersCategoryRank = computed(() => ({
  tournament: { documentId: { eq: detail.value?.documentId || "" } },
  category: { documentId: { eq: category.value?.documentId || "" } },
}));

const { result: categoryRank, refetch: refetchCategoryRank } = useQuery(
  GET_CATEGORY_RANKS,
  {
    filters: filtersCategoryRank,
    pagination: paginationOptions,
    sort: sortOptions,
  },
);

const { result: categoryTeamRank } = useQuery(GET_CATEGORY_TEAM_RANKS, {
  filters: filtersTeamRank,
  pagination: paginationOptions,
  sort: sortOptions,
});

watchEffect(() => {
  const t = tournament.value?.tournaments?.[0]?.data;
  if (!t) return;

  detail.value = t;
  total_.value = convertNumberToCurrency.formatMoney(t.award_total || 0);
  categories.value = t.categories || [];
  arenas.value = t.arenas || [];

  const mt = mapType(t.type);
  typeTournament.value = mt.label;
  isShowPlayer.value = mt.showPlayer;
  isShowTeamPlayer.value = mt.showTeam;

  const m = statusMap[t.tour_status] || {};
  status.value = m.text || "Không xác định";
  style.value = m.class || "";

  // Không cần gọi checkUserFollowStatus() nữa vì đã chuyển vào followStore
});

watch(
  categories,
  (newCategories) => {
    if (!newCategories || newCategories.length === 0) {
      optionCategories.value = [{ label: "Lựa chọn nội dung", value: "" }];
      return;
    }

    if (!selectedCategory.value || selectedCategory.value === "") {
      selectedCategory.value = newCategories[0];
      category.value = newCategories[0];
      refetchCategoryRank();
    }

    optionCategories.value = [
      ...newCategories.map((cat) => ({
        label: cat.name,
        value: cat,
      })),
    ];
  },
  { immediate: true },
);

watchEffect(() => {
  const arr = categoryRank.value?.categoryRanks || [];
  dataRank.value = arr.length ? arr : [];
});

watchEffect(() => {
  const arr = categoryTeamRank.value?.categoryTeamRanks || [];
  dataTeamRank.value = arr.length ? arr : [];
});

const searchCategory = () => {
  category.value = selectedCategory.value;
  refetchCategoryRank();
};

const url = process.env.VUE_APP_SERVER_URL;

// Sử dụng follow store
const followStore = useFollowStore();
const followLoading = computed(() => followStore.isLoading);
const isFollowing = computed(() => {
  return detail.value?.documentId
    ? followStore.isFollowing(detail.value.documentId)
    : false;
});

// Load danh sách giải đã theo dõi khi component được tạo
onMounted(async () => {
  if (authStore.user) {
    try {
      await followStore.loadFollowedTournaments();
    } catch (error) {
      console.error("Lỗi khi tải danh sách giải đã theo dõi:", error);
    }
  }

  // Kiểm tra URL có chứa openSection=matches không
  const urlParams = new URLSearchParams(window.location.search);
  const openSection = urlParams.get("openSection");

  if (openSection === "matches") {
    // Đợi một chút để đảm bảo DOM đã được render
    setTimeout(() => {
      // Tìm phần tử collapse của matches
      const matchesCollapse = document.getElementById("matches-collapseFive");
      const matchesButton = document.querySelector("#matches-ranked button");

      if (matchesCollapse && matchesButton) {
        // Thêm class show để mở collapse
        matchesCollapse.classList.add("show");
        // Thay đổi trạng thái của button
        matchesButton.classList.remove("collapsed");
        matchesButton.setAttribute("aria-expanded", "true");

        // Scroll đến phần matches
        document
          .getElementById("matches")
          .scrollIntoView({ behavior: "smooth" });
      }
    }, 500);
  }
});

/**
 * Chuyển đổi trạng thái theo dõi (theo dõi/hủy theo dõi)
 */
async function toggleFollow() {
  if (!authStore.user) {
    message.warning("Vui lòng đăng nhập để theo dõi giải đấu");
    return;
  }

  if (!detail.value?.documentId) {
    message.error("Không tìm thấy thông tin giải đấu");
    return;
  }

  try {
    const success = await followStore.toggleFollowTournament(
      detail.value.documentId,
    );
    if (success !== undefined) {
      const messageText = success
        ? "Đã theo dõi giải đấu thành công"
        : "Đã hủy theo dõi giải đấu thành công";
      message.success(messageText);
    }
  } catch (error) {
    console.error("Lỗi khi thay đổi trạng thái theo dõi:", error);
    message.error(error.value || "Có lỗi xảy ra khi thực hiện thao tác");
  }
}
</script>
